import { useTranslation } from "react-i18next";

import { Form } from "react-bootstrap";

function AutoInvoiceForm({ autoInvoice, setAutoInvoice }) {
  const { t } = useTranslation();

  return (
    <div className="invoice-page__modal_form_invoice-container">
      <Form.Group>
        <Form.Label>Numero D'immatriculation: </Form.Label>
        <Form.Control
          label="text"
          value={autoInvoice.immatriculation}
          onChange={(e) =>
            setAutoInvoice({ ...autoInvoice, immatriculation: e.target.value })
          }
        />
      </Form.Group>

      <Form.Group>
        <Form.Label>Numero de chassis: </Form.Label>
        <Form.Control
          label="text"
          value={autoInvoice.chassis_number}
          onChange={(e) =>
            setAutoInvoice({ ...autoInvoice, chassis_number: e.target.value })
          }
        />
      </Form.Group>

      <Form.Group>
        <Form.Label>Numero address:</Form.Label>
        <Form.Control
          label="text"
          value={autoInvoice.address}
          onChange={(e) =>
            setAutoInvoice({ ...autoInvoice, address: e.target.value })
          }
        />
      </Form.Group>

      <Form.Group className="u-mb-small">
        <Form.Label>Marque de la voiture: </Form.Label>
        <Form.Control
          label="Marque de la voiture:"
          type="text"
          placeholder="Hyundai"
          value={autoInvoice.brand}
          onChange={(e) =>
            setAutoInvoice({ ...autoInvoice, brand: e.target.value })
          }
        />
      </Form.Group>

      <Form.Group className="u-mb-small">
        <Form.Label>Type de voiture: </Form.Label>
        <Form.Control
          label="Type de la voiture:"
          type="text"
          placeholder="Hyundai"
          value={autoInvoice.type}
          onChange={(e) =>
            setAutoInvoice({ ...autoInvoice, type: e.target.value })
          }
        />
      </Form.Group>

      <Form.Group className="u-mb-small">
        <Form.Label>Model de voiture: </Form.Label>
        <Form.Control
          label="Model de la voiture:"
          type="text"
          placeholder="Santa Fe 3"
          value={autoInvoice.model}
          onChange={(e) =>
            setAutoInvoice({ ...autoInvoice, model: e.target.value })
          }
        />
      </Form.Group>

      <Form.Group className="u-mb-small">
        <Form.Label>Energie du vehicule: </Form.Label>
        <Form.Control
          label="Type de la voiture:"
          type="text"
          placeholder=""
          value={autoInvoice.energy}
          onChange={(e) =>
            setAutoInvoice({ ...autoInvoice, energy: e.target.value })
          }
        />
      </Form.Group>

      <Form.Group className="u-mb-small">
        <Form.Label>Puissance du vehicule: </Form.Label>
        <Form.Control
          label="Puissance du vehicule:"
          type="text"
          placeholder="15 chevaux"
          value={autoInvoice.power}
          onChange={(e) =>
            setAutoInvoice({ ...autoInvoice, power: e.target.value })
          }
        />
      </Form.Group>

      <Form.Group className="u-mb-small">
        <Form.Label>Carte grise: </Form.Label>
        <Form.Control
          label="Carte grise:"
          type="text"
          value={autoInvoice.registration_doc}
          onChange={(e) =>
            setAutoInvoice({ ...autoInvoice, registration_doc: e.target.value })
          }
        />
      </Form.Group>
    </div>
  );
}

export default AutoInvoiceForm;
